<template>
  <div class="app-wrapper">
    <app-main></app-main>
  </div>
</template>

<script>
import { AppMain } from "./components";

export default {
  name: "layout",
  components: {
    AppMain
  },
  mounted() {}
};
</script>

